export const modalES = {
  notification_mark_to_read: 'Marcar como leído',
  notification_mark_to_read_for: 'Marcar como leído durante',
  notification_mark_to_read_day: 'día',
  notification_mark_to_read_days: 'días',
}
